import {memo, useContext, useEffect, useRef, useState} from 'react';
import {Handle, Position} from 'reactflow';
import {WorkflowCanvasContext} from "../../contexts/WorkflowCanvasContextProvider";
import BlockChildNode from "./BlockChildNode";
import {MdOutlineDragIndicator} from 'react-icons/md';

import "./main_workflow_node.scss";
import Toolbar from "./Toolbar";

const WorkflowNode = ({id, data}) => {

    const workflowContext = useContext(WorkflowCanvasContext);

    const contextMenuRef = useRef(null);
    const [isInput, setIsInput] = useState(false);
    const [blockTitle, setBlockTitle] = useState(data.label);

    const [showToolbar, setShowToolbar] = useState(false);

    useEffect(() => {
        // Add event listener when the component is mounted
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Clean up event listener when the component is unmounted
            document.removeEventListener("click", handleClickOutside);
            document.addEventListener("mousedown", handleClickOutside);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickOutside = (event) => {
        if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
            setShowToolbar(false);
            workflowContext.setDeletableChildId(null)
        }
    };

    const handleToolBarVisible = e => {
        e.preventDefault();
        setShowToolbar(true);
    }

    const handleOpenDrawer = () => {
        if (data?.openNodeDrawer) {
            data.openNodeDrawer(id);
        }
    };

    const handleConnectedStyle = {
        width: "15px",
        height: "40px",
        background: "transparent",
        borderRadius: '0px',
        position: "absolute",
        border: "none",
    };

    const nodeContentStyle = {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "8px",
    };

    const handleDelete = (id) => {
        workflowContext.handleDelete(id)
        setShowToolbar(false)
    }

    const handleBlockTitle = () => {
        if (blockTitle) {
            // const updatedData = workflowContext.nodes.find(item => item.id === id);
            // updatedData.data.label = blockTitle;
            // workflowContext.setNodes((prev) => [...prev, updatedData])
            const newNodes = []
            for (let node of workflowContext.nodes) {
                if (node.id === id) {
                    node.data.label = blockTitle;
                }
                newNodes.push(node)
            }
            workflowContext.setNodes((prev) => newNodes)
        }
        setIsInput(false)
    }

    const isPreview = workflowContext.isPreview;

    // workflowCanvasContext.connectingTarget
    let isConnectingClass = ''
    if (workflowContext.connectingTarget && workflowContext.connectingTarget.id === id) {
        isConnectingClass = 'ring-2 ring-brand-lime ring-offset-1'
    }
    return (
        <div style={{position: "relative"}} className="group">
            <div
                className={`workflow-node rounded-2xl border border-gray-200 bg-gray-50/90 p-1 shadow-sm ring-0
                    transition-shadow duration-200 hover:shadow-md
                      ${isConnectingClass}`}
                onClick={() => setShowToolbar(false)}
                onContextMenu={handleToolBarVisible}
                onDoubleClick={handleOpenDrawer}
                // style={{backgroundColor: "#DDE4EA", borderRadius: "4px"}}

            >

                <div
                    className="custom-drag-handle absolute -right-2.5 -top-2.5 z-10 flex h-7 w-7 cursor-grab items-center justify-center
                        rounded-lg border border-gray-200 bg-white text-gray-400 opacity-0 shadow-sm transition-all duration-200
                        hover:text-gray-700 hover:shadow-md group-hover:opacity-100 active:cursor-grabbing"
                    title="Drag"
                >
                    <MdOutlineDragIndicator size={16} />
                </div>

                {/*<Handle*/}
                {/*    type="target"*/}
                {/*    position={Position.Left}*/}
                {/*    style={handleConnectedStyle}*/}
                {/*    id={`target-${id}`}*/}
                {/*/>*/}

                <Handle style={handleConnectedStyle} type="target" position={Position.Top} id={`target-${id}-top`}
                        className="connector top"/>

                <Handle style={handleConnectedStyle} type="target" position={Position.Bottom} id={`target-${id}-bottom`}
                        className="connector bottom"/>

                {/* Left Connectors */}
                <Handle style={handleConnectedStyle} type="target" position={Position.Left} id={`target-${id}-left-top`}
                        className="connector left-top"/>
                <Handle style={handleConnectedStyle} type="target" position={Position.Left} id={`target-${id}-left-bottom`}
                        className="connector left-bottom"/>

                {/* Right Connectors */}
                <Handle style={handleConnectedStyle} type="target" position={Position.Right} id={`target-${id}-right-top`}
                        className="connector right-top"/>
                <Handle style={handleConnectedStyle} type="target" position={Position.Right} id={`target-${id}-right-bottom`}
                        className="connector right-bottom"/>


                <div style={nodeContentStyle}>
                    {(!isPreview && isInput) ?
                        <input autoFocus type="text"
                               onBlur={handleBlockTitle}
                               className="mb-1.5 w-full rounded-lg border border-gray-300 bg-white px-2 py-1 text-sm font-semibold
                                   text-gray-900 outline-none transition-all focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10"
                               value={blockTitle}
                               onChange={(e) => setBlockTitle(e.target.value)}
                        /> :
                        <div style={{display: "flex", justifyContent: "start", position: "relative"}}>
                            <p
                                className="block-title mb-1.5 w-full truncate rounded-lg px-2 py-1 text-sm font-semibold
                                    text-gray-700 outline-none transition-colors"
                                onClick={() => setIsInput(true)}
                            >
                                {blockTitle}
                            </p>
                        </div>
                    }


                    <BlockChildNode
                        blockChildren={data.children}
                        id={id}
                        setDeletableChildId={workflowContext.setDeletableChildId}
                        setShowToolbar={setShowToolbar}
                    />

                </div>
            </div>

            {showToolbar &&
                <Toolbar
                    contextMenuRef={contextMenuRef}
                    id={id}
                    handleDelete={handleDelete}/>
            }
        </div>
    );
};

export default memo(WorkflowNode);
